import styled from 'styled-components';
import {
  SectionParent,
  BlueButton,
} from '../../../components/StyledComponents';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import React from 'react';
import app from '../../../assets/v2/Product/app.svg';
import device from '../../../assets/v2/Product/device.svg';
import groups from '../../../assets/v2/Product/groups.svg';
import gms from '../../../assets/v2/Product/gms.svg';
import kiosk from '../../../assets/v2/Product/kiosks.svg';
import report from '../../../assets/v2/Product/reports.svg';
import alert from '../../../assets/v2/Product/alert.svg';
import geofence from '../../../assets/v2/Product/geofence.svg';
import ota from '../../../assets/v2/Product/ota.svg';
import provision from '../../../assets/v2/Product/provision.svg';
import view from '../../../assets/v2/Product/remote-view.svg';
import control from '../../../assets/v2/Product/control.svg';
import support from '../../../assets/v2/Product/support.svg';
import lottie, { AnimationItem } from 'lottie-web';
import { navigate } from 'gatsby';
import { placeholderKeyframe } from './ProductSectionTwo';

const Section = styled(SectionParent)`
  background-repeat: no-repeat;
  background-color: #ffffff;
  padding-top: 5rem !important;
  padding-bottom: 4rem !important;
  background-size: contain;
  @media (max-width: 1680px) and (min-width: 1440px) {
    padding: 2rem;
    padding-left: 5rem;
    padding-right: 0;
  }
  @media (max-width: 1440px) and (min-width: 768px) {
    padding: 2rem;
    padding-left: 5rem;
    padding-right: 0;
  }
  @media (max-width: 768px) {
    padding: 3rem;
    padding-top: 3rem !important;
    padding-bottom: 2rem !important;
  }
  @media (max-width: 520px) {
    padding: 1rem;
    padding-top: 3rem !important;
    padding-bottom: 2rem !important;
  }

  width: 100%;
  display: grid;
`;

const Heading = styled.div`
  font-size: 36px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.61;
  letter-spacing: normal;
  color: #151828;
  text-align: center;
  padding-bottom: 1rem;
  @media (max-width: 520px) {
    font-size: 24px;
  }
`;

const SubHeading = styled.div`
  font-size: 18px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  text-align: center;
  display: grid;
  justify-self: center;
  padding-bottom: 2rem;
  color: #4f5263;
  @media (min-width: 1000px) {
    max-width: 620px;
  }
  @media (min-width: 800px) and (max-width: 990px) {
    width: 50%;
  }
  @media (max-width: 768px) {
    padding: 0;
    padding-bottom: 2rem;
    width: 100%;
  }
  @media (max-width: 520px) {
    font-size: 14px;
  }
`;

const FirstSectionContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  justify-content: start;
  padding-top: 3rem;
  @media (max-width: 768px) {
    padding-top: 0;
    margin-top: -2rem;
  }
`;

const GridLeft = styled.div`
  display: grid;
  grid-column: span 1;
  justify-content: end;
  padding-right: 2rem;
  align-items: center;
  @media (max-width: 768px) {
    grid-column: span 2;
    padding-right: 0;
    justify-content: center;
  }
  @media (max-width: 768px) {
    margin: 3rem 0;
    margin-top: 0;
  }
`;

const LeftTitle = styled.div`
  font-size: 28px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #151828;
  text-align: center;
  margin-bottom: 2rem;
  @media (max-width: 1400px) {
    margin-bottom: 0rem;
    font-size: 24px;
  }
  @media (max-width: 768px) {
    display: none;
  }
`;

const LeftTitleMobile = styled(LeftTitle)`
  display: none;
  @media (max-width: 768px) {
    display: block;
    margin-bottom: 4rem;
  }
  @media (max-width: 520px) {
    font-size: 22px;
  }
`;

const TitleBottom = styled(LeftTitle)`
  margin-bottom: 1.5rem;
  @media (max-width: 1350px) {
    margin-bottom: 2rem;
    font-size: 24px;
  }
`;

const TitleBottomMobile = styled(TitleBottom)`
  display: none;
  @media (max-width: 768px) {
    display: block;
    margin-top: 5rem;
  }
  @media (max-width: 520px) {
    font-size: 22px;
  }
`;

const GridLeftContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  height: 80%;
  margin-top: -5rem;
  @media (max-width: 1350px) {
    margin-top: 0;
  }
  @media (max-width: 520px) {
    padding-right: 2rem;
  }
`;

const GridItemBottom = styled.div`
  grid-column: span 1;
  justify-self: center;
  border-radius: 5px;
  max-width: 100%;
  /* margin-top: 2rem; */
  @media (max-width: 1024px) {
    margin-top: 0;
    justify-self: start !important;
    padding-left: 0 !important;
  }
  @media (max-width: 768px) {
    grid-column: span 2;
    width: 100%;
    justify-self: center !important;
    margin-bottom: 2rem;
  }
`;
const GridTitle = styled.div`
  font-size: 16px;
  font-weight: 500;
  min-height: 1em;
  font-weight: bold;
  margin-bottom: 0.5rem;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #151828;
  @media (max-width: 520px) {
    min-height: 1.5rem;
    line-height: normal;
  }
`;

const GridTitleBottom = styled(GridTitle)`
  font-size: 18px;
`;
const GridItemContent = styled.div`
  font-family: 'Nunito Sans', sans-serif;
  margin-bottom: 2rem;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #4f5263;
  text-align: left !important;
  @media (max-width: 520px) {
    margin-bottom: 0;
    margin-top: -7px;
  }
`;
const InnerContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
`;
const ImgWrapper = styled.div`
  display: grid;
  align-items: start;
  justify-content: end;
  padding-right: 1rem;
  grid-column: span 1;
  margin-bottom: 0.5rem;
  @media (max-width: 768px) {
    justify-items: center;
    margin-bottom: 0;
  }
  @media (max-width: 520px) {
    justify-self: center;
    margin-right: -3rem;
  }
`;

const ImgWrapperTwo = styled(ImgWrapper)`
  @media (max-width: 768px) {
    justify-self: end;
    margin-bottom: 0;
  }
  @media (max-width: 520px) {
    justify-self: center;
    margin-right: -3rem;
  }
`;
const TextWrapper = styled.div`
  display: grid;
  grid-column: span 2;
`;

const TextWrapperTwo = styled(TextWrapper)`
  align-items: center;
`;
const StyledImg = styled(LazyLoadImage)`
  height: 36px;
  width: 36px;
`;

const ImageHolder = styled(LazyLoadImage)`
  height: 56px;
  width: 56px;
`;
const TitlesContainer = styled.div`
  @media (max-width: 768px) {
    text-align: left;
    padding-left: 0rem;
  }
`;

const GridRight = styled.div`
  grid-column: span 1;
  width: 100%;
  height: 105%;

  .animation-container-item {
    /* display: none; */
    height: 500px;
    opacity: 0.5;
    border-radius: 5px;
    animation-duration: 3s;
    animation-fill-mode: forwards;
    animation-iteration-count: infinite;
    animation-name: ${placeholderKeyframe};
    animation-timing-function: linear;
    background: #efefef;
    background-image: linear-gradient(
      to right,
      #e6e4e4 0%,
      #d8d8d8 20%,
      #eaeaea 40%,
      #e6e4e4 100%
    );
  }
  canvas {
    width: 112% !important;
  }
  @media (max-width: 768px) {
    grid-column: span 2;
    margin-left: -0.5rem;
  }
  @media (max-width: 768px) {
    display: none;
  }
`;

const GridRightMobile = styled(GridRight)`
  display: none;
  @media (max-width: 768px) {
    display: block;
  }
`;

const SecondSectionContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  justify-content: start;
  padding-top: 5rem;
  padding-right: 5rem;
  @media (max-width: 768px) {
    padding-right: 0rem;
    padding-top: 2rem;
  }
  @media (max-width: 768px) {
    margin-top: -3rem;
  }
`;
const SecondGridLeft = styled.div`
  display: grid;
  grid-column: span 1;
  justify-content: center;
  @media (max-width: 768px) {
    grid-column: span 2;
  }
`;
const AnimationContainerKiosk = styled.div`
  display: grid;
  grid-column: span 1;
  justify-content: center;
  height: 40rem;
  @media (max-width: 768px) {
    height: 30rem;
  }
  .animation-container-item {
    /* display: none; */
    height: 700px;
    opacity: 0.5;
    border-radius: 5px;
    animation-duration: 3s;
    animation-fill-mode: forwards;
    animation-iteration-count: infinite;
    animation-name: ${placeholderKeyframe};
    animation-timing-function: linear;
    background: #efefef;
    background-image: linear-gradient(
      to right,
      #e6e4e4 0%,
      #d8d8d8 20%,
      #eaeaea 40%,
      #e6e4e4 100%
    );
  }
`;

const AnimationContainerWifi = styled(AnimationContainerKiosk)`
  height: 4rem !important;
  margin-bottom: -1rem;
`;
const SecondGridRight = styled.div`
  display: grid;
  grid-column: span 1;
  justify-content: center;
  height: fit-content;
  align-self: center;
  @media (max-width: 768px) {
    grid-column: span 2;
  }
`;

const RightContainer = styled.div`
  display: flex;
  justify-items: start;
  padding-bottom: 1rem;
  @media (max-width: 768px) {
    justify-self: center;
    width: 100%;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
  }
`;

const BlueButtonNew = styled(BlueButton)`
  margin-top: 1rem;
  width: 25rem;
  @media (max-width: 768px) {
    justify-self: center;
    width: 23rem;
  }
  @media (max-width: 520px) {
    width: 18rem;
    justify-self: center;
  }
`;

const ConditionText = styled.div`
  font-size: 18px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #626679;
  margin-top: 1.5rem;
  font-style: italic;
  width: 65%;
  text-align: center;
  @media (max-width: 1100px) {
    width: 100%;
  }
`;
export default class ProductSectionThree extends React.Component<any, any> {
  animationlap?: AnimationItem;
  animationkiosk?: AnimationItem;
  animationwifi?: AnimationItem;
  isCMounted = true;
  laptopAnimation: any;

  constructor(props: any) {
    super(props);
    this.animationlap = undefined;
    this.animationkiosk = undefined;
    this.animationwifi = undefined;
    this.state = {
      startAnimation: false,
      startLapAnimation: false,
    };
  }

  componentDidMount() {
    this.isCMounted = true;
    this.loadAnimationMobile();
    window.onscroll = this.scrollFunction;
  }

  loadAnimationMobile = async () => {
    if (window.innerWidth <= 768) {
      this.laptopAnimation = await import('../../lottieAnimations/laptop.json');
      this.animationlap = lottie.loadAnimation({
        name: 'animation-lap',
        container: document.getElementById('lap-animation-mobile')!,
        loop: true,
        renderer: 'canvas',
        autoplay: true,
        animationData: this.laptopAnimation,
      });
    }
  };
  scrollFunction = () => {
    if (!this.state.startAnimation) {
      const elem = document.querySelector('#kiosk-animation');
      if (elem) {
        const bounding = elem.getBoundingClientRect();
        // console.log('bounding', bounding);
        if (bounding.top < window.innerHeight) {
          // Do what you want to do over here...
          this.setState({ startAnimation: true }, async () => {
            const wifiAnimation = await import(
              '../../lottieAnimations/wifi.json'
            );
            this.animationwifi = lottie.loadAnimation({
              name: 'animation-wifi',
              container: document.getElementById('wifi-animation')!,
              loop: true,
              renderer: 'svg',
              autoplay: true,
              animationData: wifiAnimation,
            });
            const kioskAnimation = await import(
              '../../lottieAnimations/kiosk.json'
            );
            this.animationkiosk = lottie.loadAnimation({
              name: 'animation-kiosk',
              container: document.getElementById('kiosk-animation')!,
              loop: true,
              renderer: 'svg',
              autoplay: true,
              animationData: kioskAnimation,
            });
          });
        }
      }
    }
    if (!this.state.startLapAnimation && window.innerWidth > 768) {
      const elem = document.querySelector('#lap-animation');
      if (elem) {
        const bounding = elem.getBoundingClientRect();
        // console.log('bounding', bounding);
        if (bounding.top < window.innerHeight) {
          // Do what you want to do over here...
          this.setState({ startLapAnimation: true }, async () => {
            this.laptopAnimation = await import(
              '../../lottieAnimations/laptop.json'
            );
            this.animationlap = lottie.loadAnimation({
              name: 'animation-lap',
              container: document.getElementById('lap-animation')!,
              loop: true,
              renderer: 'canvas',
              autoplay: true,
              animationData: this.laptopAnimation,
            });
          });
        }
      }
    }
  };

  render() {
    return (
      <Section>
        <Heading>{this.props?.messages?.HomePageFutureOfMDMTitle}</Heading>
        <SubHeading>
          {this.props?.messages?.HomePageFutureOfMDMDesc1}
        </SubHeading>
        <LeftTitleMobile>
          {this.props?.messages?.HomePageAndroidManagementFeaturesTitle}
        </LeftTitleMobile>
        <FirstSectionContainer>
          <GridRightMobile id="lap-animation-mobile" />
          <GridLeft>
            <LeftTitle>
              {this.props?.messages?.HomePageAndroidManagementFeaturesTitle}
            </LeftTitle>
            <GridLeftContainer>
              <GridItemBottom>
                <InnerContainer>
                  <ImgWrapper>
                    <StyledImg src={app} />
                  </ImgWrapper>
                  <TextWrapper>
                    <TitlesContainer>
                      <GridTitle>
                        {this.props?.messages?.HomePageAppManagementTitle}
                      </GridTitle>
                    </TitlesContainer>
                    <GridItemContent>
                      {this.props?.messages?.HomePageAppManagementDesc}
                    </GridItemContent>
                  </TextWrapper>
                </InnerContainer>
              </GridItemBottom>

              <GridItemBottom>
                <InnerContainer>
                  <ImgWrapper>
                    <StyledImg src={device} />
                  </ImgWrapper>
                  <TextWrapper>
                    <TitlesContainer>
                      <GridTitle>
                        {this.props?.messages?.HomePageDeviceManagementTitle}
                      </GridTitle>
                    </TitlesContainer>
                    <GridItemContent>
                      {this.props?.messages?.HomePageDeviceManagementDesc}
                    </GridItemContent>
                  </TextWrapper>
                </InnerContainer>
              </GridItemBottom>

              <GridItemBottom>
                <InnerContainer>
                  <ImgWrapper>
                    <StyledImg src={groups} />
                  </ImgWrapper>
                  <TextWrapper>
                    <TitlesContainer>
                      <GridTitle>
                        {this.props?.messages?.HomePageDeviceGroupTItle}
                      </GridTitle>
                    </TitlesContainer>
                    <GridItemContent>
                      {this.props?.messages?.HomePageDeviceGroupDesc}
                    </GridItemContent>
                  </TextWrapper>
                </InnerContainer>
              </GridItemBottom>

              <GridItemBottom>
                <InnerContainer>
                  <ImgWrapper>
                    <StyledImg src={gms} />
                  </ImgWrapper>
                  <TextWrapper>
                    <TitlesContainer>
                      <GridTitle>
                        {this.props?.messages?.HomePageGMSAOSPTitle}
                      </GridTitle>
                    </TitlesContainer>
                    <GridItemContent>
                      {this.props?.messages?.HomePageGMSAOSPDesc}
                    </GridItemContent>
                  </TextWrapper>
                </InnerContainer>
              </GridItemBottom>

              <GridItemBottom style={{ width: '100%' }}>
                <InnerContainer>
                  <ImgWrapper>
                    <StyledImg src={kiosk} />
                  </ImgWrapper>
                  <TextWrapper>
                    <TitlesContainer>
                      <GridTitle>
                        {this.props?.messages?.HomePageKioskModeTitle}
                      </GridTitle>
                    </TitlesContainer>
                    <GridItemContent>
                      {this.props?.messages?.HomePageKioskModeDesc}
                    </GridItemContent>
                  </TextWrapper>
                </InnerContainer>
              </GridItemBottom>

              <GridItemBottom>
                <InnerContainer>
                  <ImgWrapper>
                    <StyledImg src={report} />
                  </ImgWrapper>
                  <TextWrapper>
                    <TitlesContainer>
                      <GridTitle>
                        {this.props?.messages?.HomePageReportsTitle}
                      </GridTitle>
                    </TitlesContainer>
                    <GridItemContent>
                      {this.props?.messages?.HomePageReportsDesc}
                    </GridItemContent>
                  </TextWrapper>
                </InnerContainer>
              </GridItemBottom>

              <GridItemBottom style={{ width: '100%' }}>
                <InnerContainer>
                  <ImgWrapper>
                    <StyledImg src={alert} />
                  </ImgWrapper>
                  <TextWrapper>
                    <TitlesContainer>
                      <GridTitle>
                        {this.props?.messages?.HomePageAlertsTitle}
                      </GridTitle>
                    </TitlesContainer>
                    <GridItemContent>
                      {this.props?.messages?.HomePageAlertsDesc}
                    </GridItemContent>
                  </TextWrapper>
                </InnerContainer>
              </GridItemBottom>

              <GridItemBottom>
                <InnerContainer>
                  <ImgWrapper>
                    <StyledImg src={geofence} />
                  </ImgWrapper>
                  <TextWrapper>
                    <TitlesContainer>
                      <GridTitle>
                        {this.props?.messages?.HomePageGeofencingTitle}
                      </GridTitle>
                    </TitlesContainer>
                    <GridItemContent>
                      {this.props?.messages?.HomePageGeofencingDesc}
                    </GridItemContent>
                  </TextWrapper>
                </InnerContainer>
              </GridItemBottom>
            </GridLeftContainer>
          </GridLeft>
          <GridRight id="lap-animation">
            {!this.state.startLapAnimation && (
              <div className="animation-container-item" />
            )}
          </GridRight>
        </FirstSectionContainer>
        <TitleBottomMobile>
          {' '}
          {
            this.props?.messages
              ?.HomePageAdvancedAndroidManagementFeaturesTitle1
          }{' '}
          {this.props.messages?.HomePageAdvancedAndroidManagementFeaturesTitle2}
        </TitleBottomMobile>
        <SecondSectionContainer>
          <SecondGridLeft>
            <AnimationContainerWifi id="wifi-animation" />
            <AnimationContainerKiosk id="kiosk-animation">
              {!this.state.startAnimation && (
                <div className="animation-container-item" />
              )}
            </AnimationContainerKiosk>
          </SecondGridLeft>
          <SecondGridRight>
            <TitleBottom style={{ textAlign: 'left' }}>
              {
                this.props?.messages
                  ?.HomePageAdvancedAndroidManagementFeaturesTitle1
              }{' '}
              {
                this.props.messages
                  ?.HomePageAdvancedAndroidManagementFeaturesTitle2
              }
            </TitleBottom>
            <RightContainer>
              <ImgWrapperTwo>
                <ImageHolder src={ota} />
              </ImgWrapperTwo>
              <TextWrapperTwo>
                <TitlesContainer>
                  <GridTitleBottom>
                    {this.props?.messages?.HomePageOTATitle}*
                  </GridTitleBottom>
                </TitlesContainer>
              </TextWrapperTwo>
            </RightContainer>
            <RightContainer>
              <ImgWrapperTwo>
                <ImageHolder src={provision} />
              </ImgWrapperTwo>
              <TextWrapperTwo>
                <TitlesContainer>
                  <GridTitleBottom>
                    {this.props?.messages?.HomePageNoTouchProvisioningTitle}
                  </GridTitleBottom>
                </TitlesContainer>
              </TextWrapperTwo>
            </RightContainer>
            <RightContainer>
              <ImgWrapperTwo>
                <ImageHolder src={view} />
              </ImgWrapperTwo>
              <TextWrapperTwo>
                <TitlesContainer>
                  <GridTitleBottom>
                    {this.props?.messages?.HomePageRemoteViewTitle}
                  </GridTitleBottom>
                </TitlesContainer>
              </TextWrapperTwo>
            </RightContainer>
            <RightContainer>
              <ImgWrapperTwo>
                <ImageHolder src={control} />
              </ImgWrapperTwo>
              <TextWrapperTwo>
                <TitlesContainer>
                  <GridTitleBottom>
                    {this.props?.messages?.HomePageRemoteControlTitle}
                  </GridTitleBottom>
                </TitlesContainer>
              </TextWrapperTwo>
            </RightContainer>
            <RightContainer>
              <ImgWrapperTwo>
                <ImageHolder src={support} />
              </ImgWrapperTwo>
              <TextWrapperTwo>
                <TitlesContainer>
                  <GridTitleBottom>
                    {this.props?.messages?.HomePageHardwareSupportTitle}
                  </GridTitleBottom>
                </TitlesContainer>
              </TextWrapperTwo>
            </RightContainer>
            <BlueButtonNew
              id="product__request_custom_price_quote"
              onClick={() =>
                navigate(
                  this.props?.messages?.locale !== 'en'
                    ? `/${this.props?.messages?.locale}/book-demo`
                    : '/book-demo'
                )
              }
            >
              {this.props?.messages?.HomePageCustomPriceCTA}
            </BlueButtonNew>
            <ConditionText>
              *{this.props?.messages?.HomePageSupportedDeviceAsterix}
            </ConditionText>
          </SecondGridRight>
        </SecondSectionContainer>
      </Section>
    );
  }
}
